import { StyleSheet } from 'react-native'

const useStyles = (theme, isDesktop) => StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  card: {
    flex: 1,
    marginVertical: 10,
    marginRight: 10
  },
  content: {
    borderLeftWidth: 4,
    paddingBottom: 10,
    backgroundColor: theme.CARD_BACKGROUND
  },
  rightInfoItem: {
    flex: 1
  },
  typeBadge: {
    width: 75,
    marginTop: isDesktop ? 0 : 10,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 3
  },
  hour: {
    alignItems: 'flex-start',
    marginRight: 15,
    width: 40
  },
  arrow: {
    marginRight: 2
  },
  endHour: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  end: {
    fontSize: 10
  }
})

export default useStyles
